export default __webpack_public_path__ + "static/how-it-works-process-1515d26bf42f629c010eb7a963797990.png";